import { render, staticRenderFns } from "./SBNotes.vue?vue&type=template&id=0fc0c83c"
import script from "./SBNotes.vue?vue&type=script&lang=js"
export * from "./SBNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports